import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from 'projects/visa-platform/src/app/shared/services/auth.service';

export const authGuard = (): boolean | UrlTree => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/']);
};
